export default {
  zh: {
    download: '下载',
    downloadVpn: '下载',
    client: '客户端'
  },
  en: {
    download: 'Download',
    downloadVpn: 'Download VPN for ',
    client: ' '
  }
}



// WEBPACK FOOTER //
// ./src/views/download/lang.js